class TappiReveal {
  constructor() {
    this.items = document.querySelectorAll('.tappi-reveal');
    if (!this.items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    this.items.forEach((item) => this.observer.observe(item));
  }
}

document.addEventListener('DOMContentLoaded', () => new TappiReveal());
document.addEventListener('shopify:section:load', () => new TappiReveal());
